import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-feedback-card',
  templateUrl: './feedback-card.component.html',
  styleUrls: ['./feedback-card.component.css']
})
export class FeedbackCardComponent implements OnInit {

  constructor() { }

  @Input() feedback;
  @Output() navAction = new EventEmitter();

  ngOnInit() {
  }

  getNav(data) {
    this.navAction.emit(data);
  }

}
